import {ChangeDetectorRef, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AuthService} from "../../shared/services/auth.service";
import {StorageService} from "../../shared/services/storage/storage.service";
import {Router} from "@angular/router";
import { PrimaryButtonComponent } from '../../shared/components/buttons/primary-button/primary-button.component';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'app-error-modal',
    templateUrl: './error-modal.component.html',
    styleUrl: './error-modal.component.css',
    standalone: true,
    imports: [TranslocoModule, MatIcon, NgIf, PrimaryButtonComponent]
})
export class ErrorModalComponent {

    public message: any;
    public stacktrace: string;
    public showStacktrace: boolean = false;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<ErrorModalComponent>,
                private authService: AuthService,
                private storageService: StorageService,
                private cdRef: ChangeDetectorRef,
                private router: Router) {
        this.message = data.message;
        this.stacktrace = data.stacktrace;

        this.stacktrace = this.stacktrace.replaceAll("\n", "<br>")
    }

    deleteCacheAndReload() {
        this.storageService.clear();
        this.authService.SignOut().then(() => {
            this.dialogRef.close();
            this.router.navigate(['dashboard/sign-in']);
        });
    }

    toggleStacktrace() {
        this.showStacktrace = !this.showStacktrace;
        this.cdRef.detectChanges();
    }
}
